import { createTheme }                  from '@mui/material/styles'
import { variable }                     from './variables'

const FONT = 'Roboto, sans-serif'

const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          scrollBehavior: "smooth",
        },
        "@media only screen and (min-width: 600px)": {
          "*::-webkit-scrollbar": {
            width: 8,
          },
          "*::-webkit-scrollbar-track": {
            borderRadius: 10,
            opacity: 0.1,
          },
          "*::-webkit-scrollbar-thumb": {
            backgroundColor: variable.darkest,
            opacity: 0.1,
            borderRadius: 10,
            zIndex: 9999,
          },
        },
      },
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backdropFilter: "blur(5px)",
          backgroundColor: variable.backdropColor,
        },

      },
    },
    MuiPopover: {
      styleOverrides: {
        root: {
          '& .MuiBackdrop-root': {
            opacity: '0.2!important',
          }
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          "& .MuiPickersDay-dayDisabled": {
            opacity: "0.2",
          },
        },
      },
    },
    MuiDateCalendar: {
      styleOverrides: {
       root: {
          '& .Mui-disabled': {
            opacity: '0.2!important',
          }
       }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          paddingRight: 0,
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontWeight: "normal",
          justifyContent: "flex-start",
          minHeight: 40,
        },
        iconWrapper: {
          fontSize: 20,
          marginBottom: 0,
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-input": {
            paddingTop: 10,
            paddingBottom: 10,
          },
          "& .MuiFormHelperText-root": {
            fontSize: variable.f2,
            marginLeft: 0,
          },
          "& .MuiOutlinedInput-multiline": {
            padding: "0 12px!important", // override MuiOutlinedInput-input padding to avoid extra padding in multiline textarea
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        outlinedSizeSmall: {
          fontSize: "inherit",
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: 4,
        },
      },
    },
    MuiIcon: {
      styleOverrides: {
        '& .fontSizeMedium': {
          fontSize: variable.f3,
        },
      }
    }
  },

  mixins: {
    displayCenter: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    textEllipsis: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  palette: {
    common: {
      black: variable.black,
      sideNav: variable.black,
      sidePanel: variable.darker,
      main: variable.dark,
      bgBtn: variable.primaryColor,
      navHover: variable.dark,
      navActive: variable.dark,
      border: variable.borderColor,
      iconColor: variable.iconColor,
      navLink: variable.white,
      tertiaryColor: variable.tertiaryColor,
    },
    mode: "dark",
    primary: {
      main: variable.primaryColor,
      contrastText: variable.white,
    },
    secondary: {
      main: variable.secondaryColor,
      contrastText: variable.white,
    },
    error: {
      main: variable.error,
    },
    warning: {
      main: variable.warning,
    },
    text: {
      primary: variable.textColor,
      secondary: variable.white,
    },
    divider: variable.borderColor,
    background: {
      paper: variable.darkest,
      default: variable.dark,
    },
    shadows: {
      0: "none",
      1: "3px 3px 12px 2px rgba(0,0,0,0.6)",
      2: "0px 0px 4px 8px rgba(30, 30, 30, 0.40)",
      3: "0px 0px 8px 4px rgba(30, 30, 30, 0.40)",
      4: "0px 4px 6px 2px rgba(0, 0, 0, 0.25)",
    },
  },
  typography: {
    htmlFontSize: 10,
    fontFamily: FONT,
    f1: variable.f1,
    f2: variable.f2,
    f3: variable.f3,
    f4: variable.f4,
    f5: variable.f5,
    f6: variable.f6,
    f7: variable.f7,

    iconLarge: variable.sizeLarge,
    iconMedium: variable.sizeMedium,
    iconSmall: variable.sizeSmall,

    h1: {
      fontFamily: FONT,
      fontSize: variable.f5,
      fontWeight: "bold",
    },
    h2: {
      fontFamily: FONT,
      fontSize: variable.f4,
      fontWeight: "bold",
    },
    h3: {
      fontFamily: FONT,
      fontSize: variable.f3,
      fontWeight: "bold",
    },
    h4: {
      fontFamily: FONT,
      fontSize: variable.f3,
      fontWeight: "bold",
    },
    subtitle1: {
      fontFamily: FONT,
      fontSize: variable.f4,
      lineHeight: 1.4,
    },
    subtitle2: {
      fontFamily: FONT,
      fontSize: variable.f3,
      lineHeight: 1.3,
    },
    body1: {
      fontFamily: FONT,
      fontSize: variable.f2,
    },
    body2: {
      fontFamily: FONT,
      fontSize: variable.f1,
    },
    button: {
      fontFamily: FONT,
      fontSize: "inherit",
      fontWeight: "bold",
      textTransform: "capitalize",
    },
    popover: {
      border: "2px solid white",
    },
    icon: {
      fontSize: "inherit",
    },
  },
});

export default theme